export class Colors {
   static SAM_GREEN = 'rgba(171, 211, 62, 1)';
   static SAM_RED = 'rgba(239, 22, 22, 1)';
}
